
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import type { Label } from '@/data';
import type SharedActions from '@/logic/SharedActions';
import LabelBehavior from '../LabelBehavior.vue';

/**
 * Select a label when clicking/tapping on it
 */
@Component
export default class BSelectOnClick extends LabelBehavior {
  mounted() {
    // This registers an event on the parent LabelCanvas
    this.register('label-mousedown', (_:unknown, label: Label) => {
      this.actions.select(label.id);
    });
  }

  @Prop({ required: true })
  actions!: SharedActions;
}
